export default {"src":"/_next/static/media/taxes.9b93520b.svg","height":430,"width":430,"blurWidth":0,"blurHeight":0};